import { Trans, t } from '@lingui/macro'
import { myI18n } from 'translation/I18nConnectedProvider'

export const FormBudgetError = error => {

  if (!error.expenses && !error.revenues) {
    return error
  }

  const expenseErrors = error.expenses ? Object.keys(error.expenses)
    .filter(key => error.expenses[key])
    .map(key => {
      const line = error.expenses[key]?.comment
      return (
        <li key={`expense-${key}`} style={{listStyle: 'none'}}>
          <u>
            {key}
            {', '}
            <Trans>Expenses</Trans>
          </u>
          <ul>
            {line && (
              <li key={line}>
                <b><Trans>Comments</Trans></b>{`: `}
                <Trans>{line}</Trans>
              </li>
            )}
          </ul>
        </li>
      )
    }) : []

  const revenueErrors = error.revenues ? Object.keys(error.revenues)
    .filter(key => error.revenues[key])
    .map(key => {
      const line = error.revenues[key]?.comment
      return (
        <li key={`revenue-${key}`} style={{listStyle: 'none'}}>
          <u>
            {key}
            {', '}
            <Trans>Revenues</Trans>
          </u>
          <ul>
            {line && (
              <li key={line}>
                <b><Trans>Comments</Trans></b>{`: `}
                <Trans>{line}</Trans>
              </li>
            )}
          </ul>
        </li>
      )
    }) : []

  return { toMap: [...expenseErrors, ...revenueErrors] }
}